import "./App.css";
import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header.jsx"
import Footer from "./components/Footer.jsx"
import Login from "./Pages/Login.jsx"
import Admin from "./Pages/Admin.jsx";
import Employee from "./Pages/Employee.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Shift from "./components/Shift.jsx";
import Report from "./components/Reports.jsx";
import Forgot from "./components/Forgot.jsx";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("userdetails"));

  localStorage.setItem("manualLogout", "true");

  const manualLogout = localStorage.getItem("manualLogout") === "true";
  if (!user) {
    if (!manualLogout) {
      alert("Session expired or not logged in. Redirecting to login.");
    }
    localStorage.removeItem("manualLogout"); 
    return <Navigate to="/" replace />;
  }

  return children;
};

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("userdetails");
    setIsLoggedIn(!!user);
  }, []);

  return (
    <div className="app">
      <Router>
        <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/resetpassword" element={<Forgot />} />

            <Route
              path="/ad"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />

            <Route
              path="/CU"
              element={
                <ProtectedRoute>
                  <Employee />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shift"
              element={
                <ProtectedRoute>
                  <Shift />
                </ProtectedRoute>
              }
            />

            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Report />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
      </Router>
      
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
    </div>
  );
};

export default App;